import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { IconSquareCheck, IconSquareCheckFilled } from '@tabler/icons-react'
import type { AccordionItem } from './MyNaviFilterAccordionList'

export type { AccordionItem as FilterListItem }

export type MyNaviFilterListProps = {
  items: AccordionItem[]
  /** 「すべて」行のチェック状態。省略時は「すべて」行を表示しない */
  allChecked?: boolean
  /** 「すべて」行クリック時のコールバック。省略時は「すべて」行を表示しない */
  onToggleAll?: () => void
}

const FONT_STYLE = { fontFamily: "'BIZ UDPGothic', sans-serif" }

function CheckboxIcon({ checked }: { checked: boolean }) {
  return checked ? (
    <IconSquareCheckFilled size={16} color="#058bbe" className="flex-shrink-0" />
  ) : (
    <IconSquareCheck size={16} color="#686868" strokeWidth={1.5} className="flex-shrink-0" />
  )
}

export function MyNaviFilterList({ items, allChecked, onToggleAll }: MyNaviFilterListProps) {
  const showAll = allChecked !== undefined && onToggleAll !== undefined

  return (
    <div className="flex flex-col">
      {/* すべて行（props が揃っている場合のみ表示） */}
      {showAll && (
        <button
          type="button"
          onClick={onToggleAll}
          className="flex items-center justify-between h-[38px] px-[17px] w-full bg-[#f8f8f8] border-b border-[#e5e5e5]"
        >
          <MyNaviTypography variant="label">すべて</MyNaviTypography>
          <CheckboxIcon checked={allChecked} />
        </button>
      )}

      {/* 個別アイテム行 */}
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={item.onToggle}
          className="flex items-center justify-between h-[38px] px-[17px] w-full bg-[#f8f8f8] border-b border-[#e5e5e5]"
        >
          <MyNaviTypography variant="label">{item.label}</MyNaviTypography>
          <CheckboxIcon checked={item.checked} />
        </button>
      ))}
    </div>
  )
}
